import React, { useState, useEffect } from "react";
import axios from "axios";
import BlogModal from "../../../components/AdminPanel/Blog/BlogModal";
import SideBar from "../../../components/AdminPanel/SideBar";
import Blog from "../../../components/AdminPanel/Blog/Blog";


function AdminBlog() {
    const [blogPosts, setBlogPosts] = useState([]); 
    const [filteredBlogPosts, setFilteredBlogPosts] = useState([]); 
    const [showBlogModal, setShowBlogModal] = useState(false);
    async function fetchBlogPosts() {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/blog`);
            setBlogPosts(response.data.reverse());
            setFilteredBlogPosts(response.data.reverse());
        } catch (error) {
            console.error("Error fetching blog posts:", error);
        }
    }

    useEffect(() => {
        fetchBlogPosts();
    }, []); 

    function handleSearchChange(e) {
        const searchValue = e.target.value.toLowerCase();
        const newFilteredData = blogPosts.filter((post) =>
            post.title.toLowerCase().includes(searchValue)
        );
        setFilteredBlogPosts(newFilteredData);
    }

    const onModalClose = () => {
        setShowBlogModal(false);
        fetchBlogPosts(); 
    };

    return (
        <div className="flex">
            <SideBar />
            <div className="flex flex-col md:mt-12 md:ml-[16%] font-sans w-full">
                <div className="flex flex-col sm:flex-row items-center justify-between my-6 px-4 gap-4">
                    <div className="text-left font-medium text-gray-500 py-2 text-lg whitespace-nowrap">Blog Post Management</div>
                    <input
                        name="search"
                        type="text"
                        placeholder="Search by Title"
                        onChange={handleSearchChange}
                        className="border px-3 py-2 rounded-xl w-full sm:w-[250px] focus:outline-none focus:ring-2 focus:ring-blue-500 flex-[0.75]"
                    />
                    <button
                        onClick={() => setShowBlogModal(true)} // Open modal for adding new post
                        className="bg-[#173d73] text-white px-6 py-2 rounded-xl duration-300 hover:bg-blue-700 whitespace-nowrap"
                    >
                        Add New 
                    </button>
                </div>
                {/* Pass filtered blog posts to BlogManagement component */}
                <Blog filterData={filteredBlogPosts} />

                {/* BlogModal for Add operations. BlogManagement handles edit modals internally */}
                <BlogModal isOpen={showBlogModal} onClose={onModalClose} blogId={null} />

            </div>
        </div>
    );
}

export default AdminBlog;